import { lazy } from "react";

export const HomePage = lazy(() => import('@pages/home'));

export const AuthPage = lazy(() => import('@pages/auth'));
export const LoginPage = lazy(() => import('@pages/login'));
export const JoinPage = lazy(() => import('@pages/join'));
export const SubscriptionsPage = lazy(() => import('@pages/subscriptions'));
export const SubscriptionManagementPage = lazy(() => import('@pages/subscription-management'));
export const ChatsPage = lazy(() => import('@pages/chats'))
export const ChatPage = lazy(() => import('@pages/chat'))
export const SegmentsPage = lazy(() => import('@pages/segments'))
export const SegmentPage = lazy(() => import('@pages/segment'))